import React from 'react'
import { Card, CardBody, CardHeader, Row, Col,Container } from 'reactstrap'
import AcademicIcon from 'assets/academiccounseling.svg'
import EarlyBenefitsIcon from 'assets/earlybenefit.svg'
import ScholarshipIcon from 'assets/feeIcon.svg'
import EarlyBenefits from './EarlyBenefits'

const NearestBranch = () => {
  return (
    <div>
      <Container className="px-lg-0 px-xl-0 px-3 pb-lg-0 pb-xl-3 mh-100 maxw-11">
          <Card className='mt-3 mt-lg-2 border-0'>
                <CardHeader className="bg-aqua-60 rounded-top border-0 py-2 px-3 text-white font-size-md m-0 fw-700 text-center">
                VISIT YOUR NEAREST BRANCH FOR
                </CardHeader>
                <CardBody className="p-4">
                    <Row className='text-black'>
                        <Col xs={4} className='d-flex align-content-center flex-nowrap'><p className='mb-0 branch_p'><span><img src={AcademicIcon} alt="academic Counseling"/></span>ACADEMIC COUNSELLING</p></Col>
                        <Col xs={4} className='d-flex align-content-center flex-nowrap' ><p className='mb-0 branch_p'><span><img src={EarlyBenefitsIcon} alt="Early Benefits"/></span>EARLY ADMISSION BENEFITS</p></Col>
                        <Col xs={4} className='d-flex align-content-center flex-nowrap'><p className='mb-0 branch_p'><span><img src={ScholarshipIcon} alt="scholarship"/></span>SCHOLARSHIP/FEE DETAILS</p></Col>
                    </Row>
                </CardBody>
            </Card>
          </Container>
          <EarlyBenefits/>
    </div>
  )
}

export default NearestBranch